function resolveApiUrl(): string {
  const raw = import.meta.env.PUBLIC_API_URL as string | undefined;
  if (!raw || raw.trim().length === 0) {
    throw new Error(
      "[config] Missing PUBLIC_API_URL environment variable. " +
        "It is baked at build time — rebuild the dashboard with PUBLIC_API_URL pointing at the API " +
        "that owns the auth database (e.g. https://api-tutorship.ryanmac.dev).",
    );
  }
  return raw.trim().replace(/\/+$/, "");
}

export const config = {
  apiUrl: resolveApiUrl(),
} as const;
